export type MealSlot = 'BREAKFAST' | 'LUNCH' | 'DINNER' | 'SNACK';
export type Season = 'ANY' | 'SPRING' | 'SUMMER' | 'FALL' | 'WINTER';
export type LogSource = 'SUGGESTED' | 'SWAPPED' | 'ATE_OUT';
export type Tier = 'BASE' | 'PRO';

export interface AuthUser {
  id: string;
  email: string;
  name: string | null;
  avatarUrl: string | null;
  tier: Tier;
}

export interface Product {
  id: number;
  name: string;
  caloriesPer100g: number;
  proteinPer100g: number | null;
  fatPer100g: number | null;
  carbsPer100g: number | null;
  category: string | null;
  archived: boolean;
}

export interface ProductInput {
  name: string;
  caloriesPer100g: number;
  proteinPer100g?: number | null;
  fatPer100g?: number | null;
  carbsPer100g?: number | null;
  category?: string | null;
}

// A Product as tagged onto a specific Dish, carrying that dish's own
// amount/kcal for the ingredient (e.g. "Banana slices" is 40g/60kcal on one
// dish and 80g/120kcal on another).
export interface DishProduct {
  id: number;
  name: string;
  caloriesPer100g: number;
  amountGrams: number | null;
  calories: number | null;
}

export interface DishProductInput {
  productId: number;
  amountGrams?: number | null;
  calories?: number | null;
}

export interface Dish {
  id: number;
  name: string;
  photoUrl: string | null;
  prepTimeMinutes: number | null;
  costLevel: number;
  portionDesc: string | null;
  calories: number;
  proteinGrams: number;
  satietyRating: number;
  difficultyRating: number;
  isFavorite: boolean;
  season: Season;
  isFreezable: boolean;
  isDeliveryFriendly: boolean;
  mealSlots: MealSlot[];
  products: DishProduct[];
  archived: boolean;
}

export interface DishInput {
  name: string;
  photoUrl?: string | null;
  prepTimeMinutes?: number | null;
  costLevel?: number;
  portionDesc?: string | null;
  calories: number;
  proteinGrams: number;
  satietyRating?: number;
  difficultyRating?: number;
  isFavorite?: boolean;
  season?: Season;
  isFreezable?: boolean;
  isDeliveryFriendly?: boolean;
  mealSlots: MealSlot[];
  products: DishProductInput[];
}

export interface LoggedMeal {
  id: number;
  source: LogSource;
  note: string | null;
  dish: Dish | null;
}

export interface SlotToday {
  slot: MealSlot;
  logged: LoggedMeal | null;
  suggestions: Dish[];
}

export interface TodayResponse {
  date: string;
  slots: SlotToday[];
}

export interface ShoppingListItem {
  item: string;
  count: number;
}

export interface WeightEntry {
  id: number;
  date: string;
  weightKg: number;
  waistCm: number | null;
  note: string | null;
}

export interface TrendResult {
  direction: 'down' | 'flat' | 'up' | 'insufficient_data';
  nudge: string | null;
}

export const MEAL_SLOTS: MealSlot[] = ['BREAKFAST', 'LUNCH', 'DINNER', 'SNACK'];
